<template>
  <section v-if="visible" class="container-fluid maintenance">
    <div class="row vh-100">
      <div class="d-none d-md-block col-md-3 img">
        <div :style="{ backgroundImage: `url(${bgImg})` }"></div>
      </div>
      <div class="col-12 col-md-9 d-flex align-items-center">
        <div class="w-100">
          <div class="row">
            <div class="col-12 col-md-12 login">
              <div class="row mb-5">
                <app-img
                  class="img-responsive mb-3"
                  :src="loadAssetWhiteLabel('logo.svg')"
                  alt="logo"
                  height="33"
                />
              </div>
              <div class="text-center">
                <h4>Estamos em manutenção</h4>
                <h5 class="mb-4">Voltamos em breve!</h5>
                <p>
                  Estamos realizando melhorias para oferecer uma experiência ainda melhor. <br />
                  Agradecemos pela sua compreensão.
                </p>
                <p class="mb-2">
                  <u>Tente novamente em alguns minutos.</u>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.maintenance {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--body-background);
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.img {
  padding: 18px;

  > div {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-color: #000000;
    background-image: url(@/assets/img/login/banner-1.jpg);

    transition: background-image 0.5s ease;
  }
}

.login {
  margin-left: auto;
  margin-right: auto;

  img {
    max-height: 130px;
    max-width: 266px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<script>
import { loadAssetWhiteLabel } from '@composables/utils/loadAsset.ts'
import { appImg } from 'tb-design_system-web'
import { computed, onMounted, ref } from 'vue'

import { useCache } from '@/stores/cache.js'

export default {
  name: 'MaintenanceOverlay',

  components: {
    appImg
  },
  setup() {
    const visible = computed(() => useCache().maintenance)
    const images = Object.values(
      import.meta.glob('@assets/img/login/\*.jpg', {
        eager: true,
        query: '?url',
        import: 'default'
      })
    )
    const currentImageIndex = ref(0)
    const bgImg = ref('')
    const changeBackgroundImage = () => {
      bgImg.value = images[currentImageIndex.value]
      currentImageIndex.value = (currentImageIndex.value + 1) % images.length
    }

    onMounted(() => {
      changeBackgroundImage()
      currentImageIndex.value + 1
      setInterval(changeBackgroundImage, 10000)
    })

    return {
      visible,
      bgImg,
      loadAssetWhiteLabel
    }
  }
}
</script>
